import { DynamicFieldKey_Enum } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { formatDynamicFieldKey } from '@frontend/string';
import { DynamicFieldAttributes } from '@frontend/design-system';

const INDIVIDUAL_FORM_LINK_DYNAMIC_FIELD = formatDynamicFieldKey(DynamicFieldKey_Enum.FORMS_LINK);
const GROUP_FORM_LINK_DYNAMIC_FIELD = formatDynamicFieldKey(DynamicFieldKey_Enum.FORMS_LINKS);

export const getWeaveFormDynamicField = (dynamicFields?: DynamicFieldAttributes[]) =>
  dynamicFields?.find(
    (df) => df.symbol === INDIVIDUAL_FORM_LINK_DYNAMIC_FIELD || df.symbol === GROUP_FORM_LINK_DYNAMIC_FIELD
  )?.symbol ?? INDIVIDUAL_FORM_LINK_DYNAMIC_FIELD;
